'use strict';

const storage = require('./storage-helper');

const { getUrl } = require('./slug-helper');
const { waitOnEvent } = require('./event-helper');
const { checkAnalytics } = require('./analytics-helper');
const { subscribeOnce } = require('./event-observer');

const BackTabType = 'OnlineCode';

function getURLWithEventId(redirectUrl, eventId) {
  const url = new URL(`${window.location.origin}${redirectUrl}`);

  if (eventId) {
    url.searchParams.set('eventId', eventId);
  }

  return url;
}

function handleSuccessResponse({ redemption, outlink, redirectUrl }) {
  const data = {
    ...redemption,
    isLimited: redemption.isLimitedGlobally || redemption.isLimitedPerUser,
    type: 'REDEEM',
  };

  storage.setItem('@redemption', data);

  if (outlink) {
    const eventId = storage.getItem('eventId');

    const redirectUrlWithEventId = getURLWithEventId(redirectUrl, eventId);

    if (eventId) {
      storage.setItem('eventId', '');
    }

    outlink.location.assign(redirectUrlWithEventId.href);
  }

  return data;
}

function handleFailResponse({ outlink, error }) {
  if (outlink) {
    outlink.close();
  }

  return {
    type: 'ALERT',
    errorCode: error,
    alertMessage: 'GeneralError',
  };
}

function getRedirectURL({ routes, referralSource, offerId }) {
  const params = [`currentUrl=${encodeURIComponent(window.location.href)}`];

  if (referralSource) {
    params.push(`referralSource=${referralSource}`);
  }

  return getUrl(routes.redirect.offers.replace('{offerId}', offerId), params);
}

function fetchHandler(
  apiUrl,
  { outlink, redirectUrl, isPremiumOffer },
  headers
) {
  return window
    .fetch(apiUrl, headers)
    .then(response => {
      if (response.status !== 200) {
        throw new Error(response.status);
      }

      return response.json().then(data =>
        handleSuccessResponse({
          redemption: { ...data, isPremiumOffer },
          outlink,
          redirectUrl,
        })
      );
    })
    .catch(error =>
      handleFailResponse({ outlink, error: error && error.message })
    );
}

function getRoutes() {
  const { routes } = window.Groupon.Utils.getConfigFromDom();

  return routes;
}

function redemptionHandler({
  offerId,
  referralSource,
  offerType,
  isPremiumOffer,
  merchantName,
}) {
  let outlink;
  const routes = getRoutes();
  const redirectUrl = getRedirectURL({ routes, referralSource, offerId });

  if (offerType === BackTabType) {
    storage.setItem('couponRedeemed', true);

    window.open(window.location.href, '_blank');

    outlink = window;
  } else {
    subscribeOnce('click', eventId => {
      const redirectUrlWithEventId = getURLWithEventId(redirectUrl, eventId);

      return window.open(redirectUrlWithEventId.href, '_blank');
    });
  }

  return new Promise(resolve =>
    waitOnEvent({
      doneCheck: checkAnalytics(),
      callback: resolve,
      fallback: resolve,
    })
  ).then(clientId => {
    const params = [];

    if (clientId) {
      params.push(`clientId=${clientId}`);
    }

    if (merchantName) {
      params.push(`merchant=${merchantName}`);
    }

    const redemptionUrl = getUrl(
      routes.redemption.main.replace('{offerId}', offerId),
      params
    );

    const { csrfToken } = window.Groupon.Utils.getConfigFromDom();

    const headers = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'csrf-token': csrfToken,
      },
    };

    return fetchHandler(
      redemptionUrl,
      {
        outlink,
        redirectUrl,
        isPremiumOffer,
      },
      headers
    );
  });
}

function redemptionTermsHandler({ offerId, isPremiumOffer }) {
  const routes = getRoutes();
  const termsUrl = routes.redemption.terms.replace('{offerId}', offerId);

  return fetchHandler(termsUrl, { isPremiumOffer });
}

module.exports = {
  redemptionHandler,
  redemptionTermsHandler,
  BackTabType,
};
